export enum EEOKind {
  Federal = 'ofccp',
  NonFederal = 'eeo',
}

export enum EEODataStatus {
  NoEEOData = 'no_eeo_data',
  Requested = 'requested',
  Completed = 'completed',
}

export type EEOConfiguration = {
  companySettings: EEOCompanySettingsData;
  offersWithDisabledEeoCount: number;
};

export type EEOCompanySettingsData = {
  enabled: boolean;
  id: number;
  kind: EEOKind;
  emailSubject: string;
  emailBodyHtml: string;
  dataRetentionDays: number;
};

export type EEOUpdateData = {
  enabled?: boolean;
  kind?: EEOKind;
  emailSubject?: string;
  emailBodyHtml?: string;
  dataRetentionDays?: number;
};

export type EEOCategories = {
  jobCategories: string[];
};

export type EEONoDataPlacements = {
  noEeoDataPlacementIds: number[];
};

export type NoEEODataRequest = {
  candidateId: number;
  emailSubject: string;
  emailBodyHtml: string;
};

export type BulkSendEEOData = {
  candidateIds: number[];
  emailSubject: string;
  emailBodyHtml: string;
};

export type EEOExportData = {
  dateFrom: string;
  dateTo: string;
  includeContactInformation: boolean;
};

export type BulkManageEEOData = {
  offerIds: number[];
  enabled: boolean;
  jobCategory?: string;
};
